<template>
  <div class="content md" v-if="info">
    <div class="content-title">
      <div class="content-title-btn title-btn-left">
        <a-button shape="circle" icon="left" @click="$router.go(-1)"/>
      </div>
      <div class="content-title-text">{{info.name}}行程信息</div>
    </div>
    <div class="gap"></div>
    <div class="other-title">嘉宾信息</div>
    <div class="detail-piece-content">
      <detail-list :list="info.infoList"></detail-list>
    </div>
    <div class="other-title">到达信息</div>
    <div class="detail-piece-content">
      <detail-list :list="info.arrivalInfo" v-if="info.arrival_method"></detail-list>
      <div class="no-data" v-else>未填报</div>
    </div>
    <div class="other-title">离开信息</div>
    <div class="detail-piece-content">
      <detail-list :list="info.leaveInfo" v-if="info.leave_method"></detail-list>
      <div class="no-data" v-else>未填报</div>
    </div>
    <div class="other-title">车辆安排</div>
    <div class="detail-piece-content">
      <a-table row-key="id" :columns="journeyColumns" :data-source="info.vehicleStatus" size="small">
        <template v-slot:action="text, record">
          <a class="txt-btn" @click.stop="delJourney(record)">取消安排</a>
        </template>
      </a-table>
    </div>
  </div>
</template>

<script>

    import DetailList from "../../../layouts/DetailList";
    import {getGenderText, getNeedText, getWayTypeText} from "../../../common/activity/guest";
    import {getDate} from "../../../common/js/tool";
    import {getVehicleTypeText} from "../../../common/activity/vehicle";

    export default {
        name: "GuestInfo",
        components: {
            DetailList
        },
        data() {
            return {
                info: null,
                journeyColumns: [
                    {title: '派车时间', dataIndex: 'delivery_start_time'},
                    {title: '车牌号', dataIndex: 'car_number'},
                    {title: '车辆类型', dataIndex: 'car_type'},
                    {title: '车辆品牌', dataIndex: 'brand'},
                    {title: '司机姓名', dataIndex: 'driver_name'},
                    {title: '司机手机号码', dataIndex: 'driver_tel'},
                    {title: '车辆通行证', dataIndex: 'pass'},
                    {title: '操作', key: 'action', width: 180, scopedSlots: { customRender: 'action'}}
                ]
            }
        },
        computed: {
            activity() {
                return this.$store.getters.activity;
            },
            guest() {
                return this.$route.params.guest;
            }
        },
        created() {
            this.getGuestInfo();
        },
        methods: {
            delJourney(item) {
                this.$confirm({
                    title: "提示",
                    content: '确定取消此车辆安排吗？',
                    onOk: () => {
                        const url = `/activity/activity-vehicle-allocation/${item.id}`;
                        this.$axios({
                            url,
                            method: 'DELETE'
                        }).then(this.getGuestInfo);
                    },
                });
            },
            getGuestInfo() {
                const guest = this.guest;
                const url = `/activity/activity-guest/${guest}?expand=vehicleStatus,guestImg`
                this.$axios(url).then(res => {
                    this.dealGuest(res);
                });
            },
            dealGuest(info) {
                info.infoList = [
                    {label: '姓名', value: info.name},
                    {label: '手机号码', value: info.tel},
                    {label: '性别', value: getGenderText(info.sex)},
                ]
                if(info.arrival_method) {
                    this.setWayInfoList(info, 'arrival', '到达');
                }
                if(info.leave_method) {
                    this.setWayInfoList(info, 'leave', '出发');
                }
                if(info.vehicleStatus && info.vehicleStatus.length > 0) {
                    info.vehicleStatus.forEach(item => {
                        item.showTime = `${getDate(item.delivery_start_time).pattern("yyyy-MM-dd HH:mm")} - ${getDate(item.delivery_end_time).pattern("yyyy-MM-dd HH:mm")}`;
                        item.car_number = item.vehicle ? item.vehicle.car_number : '--';
                        item.car_type = item.vehicle ? getVehicleTypeText(item.vehicle.car_type) : '--';
                        item.brand = item.vehicle ? item.vehicle.brand : '--';
                        item.driver_name = item.vehicle && item.vehicle.driver ? item.vehicle.driver.name : '--';
                        item.driver_tel = item.vehicle && item.vehicle.driver ? item.vehicle.driver.tel : '--';
                        item.pass = item.vehicle && item.vehicle.passCheck && item.vehicle.passCheck ? item.vehicle.passCheck.type : '--';
                    });
                }
                this.info = info;
            },
            setWayInfoList(info, key, prev) {
                const list = [
                    {label: prev + '方式', value: getWayTypeText(info.arrival_method)},
                ]
                const way = info[`${key}_method`];
                if(way == 1 || way == 2) {
                    list.push({label: '航班/车次', value: info[`${key}_number`]});
                } else if(way == 3) {
                    list.push({label: '车牌号', value: info[`${key}_driver`]});
                }
                list.push(
                    {label: prev + '时间', value: info[`${key}_time`]},
                    {label: prev + '地址', value: info[`${key}_address`]},
                    {label: '是否需要接送', value: getNeedText(info[`${key}_transfer`])},
                )
                info[`${key}Info`] = list;
            }
        }
    }
</script>

<style scoped>

</style>
